import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClientTableRow = ({ client, language, onEdit, onViewCases, onGenerateInvoice, onDelete }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success';
      case 'inactive':
        return 'bg-muted text-muted-foreground';
      case 'pending':
        return 'bg-warning/10 text-warning';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusLabel = (status) => {
    const labels = {
      active: { en: 'Active', fr: 'Actif', ar: 'نشط' },
      inactive: { en: 'Inactive', fr: 'Inactif', ar: 'غير نشط' },
      pending: { en: 'Pending', fr: 'En attente', ar: 'قيد الانتظار' }
    };
    return labels?.[status]?.[language] || status;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (language === 'ar') {
      return date?.toLocaleDateString('ar-MA');
    }
    return date?.toLocaleDateString('fr-MA');
  };

  return (
    <tr className="border-b border-border hover:bg-muted/50 transition-colors">
      <td className="px-4 py-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold text-sm">
            {client?.name?.split(' ')?.map(n => n?.[0])?.join('')?.toUpperCase()?.slice(0, 2)}
          </div>
          <div>
            <p className="font-medium text-foreground">{client?.name}</p>
            <p className="text-sm text-muted-foreground">{client?.clientId}</p>
          </div>
        </div>
      </td>
      <td className="px-4 py-4">
        <div className="space-y-1">
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Mail" size={14} className="text-muted-foreground" />
            <span className="text-foreground">{client?.email}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Phone" size={14} className="text-muted-foreground" />
            <span className="text-foreground">{client?.phone}</span>
          </div>
        </div>
      </td>
      <td className="px-4 py-4">
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(client?.status)}`}>
          {getStatusLabel(client?.status)}
        </span>
      </td>
      <td className="px-4 py-4">
        <div className="flex items-center gap-2">
          <span className="text-foreground font-medium">{client?.activeCases}</span>
          <span className="text-sm text-muted-foreground">
            {language === 'ar' ? 'قضايا' : language === 'fr' ? 'dossiers' : 'cases'}
          </span>
        </div>
      </td>
      <td className="px-4 py-4">
        <span className="text-sm text-foreground">{client?.practiceArea?.[language]}</span>
      </td>
      <td className="px-4 py-4">
        <span className="text-sm text-muted-foreground">{formatDate(client?.lastInteraction)}</span>
      </td>
      <td className="px-4 py-4">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(client)}
            iconName="Edit"
            iconSize={16}
          >
            <span className="sr-only">Edit</span>
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onViewCases(client)}
            iconName="Briefcase"
            iconSize={16}
          >
            <span className="sr-only">View Cases</span>
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onGenerateInvoice(client)}
            iconName="Receipt"
            iconSize={16}
          >
            <span className="sr-only">Generate Invoice</span>
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(client)}
            iconName="Trash2"
            iconSize={16}
          >
            <span className="sr-only">Delete</span>
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default ClientTableRow;